export function formatISODateToCustomFormat(isoDateString) {
    if(!isoDateString) return null;
    const dateObject = new Date(isoDateString);
  
    const day = dateObject.getUTCDate();
    const month = dateObject.getUTCMonth() + 1; // Month is zero-based, so add 1
    const year = dateObject.getUTCFullYear();
  
    // Formatting the output
    const formattedDate = `${day}-${month < 10 ? '0' : ''}${month}-${year}`;
  
    return formattedDate;
  }
  
  // Example usage
  //   const isoDateString = "2023-11-15T10:51:12.722Z";
  //   const formattedDate = formatISODateToCustomFormat(isoDateString);
  